import Tween from "tween.ts";
import Animation from "../Animation";


export default class RotateCircleAnim extends Animation {
  private Anim = Animation.getInstance();
  private isStopped = false;
  constructor(onUpdate: (a: number) => void, rotationCount: number, onComp: () => void, resolve: () => void) {
    super(); 
  
    this.rootEventBus.on(this.EnumRootEventBus.cancelledCircleAnim, () => this.isStopped = true);

    if(this.Anim.getIsCancelled()) {
      resolve();
      return 
    };
      
    const a = { radian: 0 };
    const targetRadian = rotationCount * (Math.PI * 2);
    new Tween.Tween({ ...a })
      .to({ radian: targetRadian }, 3000)
      .delay(600)
      .easing(Tween.Easing.Linear.None)
      .onUpdate(a => {
        if(this.isStopped) {
          onComp();
          return
        }
        onUpdate(a.radian);
      })
      .onComplete(() => onComp())
      .start()
  }
}